<main class="px-10 py-5 lg:px-20 lg:py-5 __page-container">

  <section class="__section-header" aria-labelledby="profile-overview-title">
    <div>
      <h1 class="__page-title">Roles & Permissions</h1>
      <p class="__page-description">Define what team members are allowed to do inside Aly</p>
    </div>
    <div class="__section_header-actions">
      <button class="__btn-main" [routerLink]="['new']">Create new Role</button>
    </div>
  </section>

  <section class="__section-filter">
    <div class="__filter-form_input-container">
      <app-input-clearable placeholder="Role name..." [value]="''"
        (onUpdate)="roleFilterForm.get('searchKeyword').setValue($event)"></app-input-clearable>
    </div>
  </section>


  <section>
    <app-data-table-scroll [inputColumns]="displayedColumns" [inputSource]="(roleList$ | async)" [inputMeta]="metaData"
      [clearShowloading]="showloading" [showloading]="showloading" (onScrollGetRecords)="nextPage()"
      (onTableRowClick)="onTableActionLinkClick($event)">
    </app-data-table-scroll>
  </section>
</main>


<router-outlet></router-outlet>
